import type { ComponentProps } from "react";
import { SlackImportForm } from "@/features/people/components/slack-import-form";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";

export function SheetUrlStep({
  sheetsUrl,
  setSheetsUrl,
  pending,
  error,
  onBack,
  onSubmit,
}: {
  sheetsUrl: string;
  setSheetsUrl: (v: string) => void;
  pending: boolean;
  error: string | null;
  onBack: () => void;
  onSubmit: () => void;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <p className="text-sm text-text-secondary">
        Paste a Google Sheets share link. The sheet must be set to{" "}
        <strong>"Anyone with the link can view"</strong>.
      </p>
      <div className="flex flex-col gap-2">
        <Label htmlFor="sheet-url">Sheets URL</Label>
        <Input
          id="sheet-url"
          type="url"
          value={sheetsUrl}
          onChange={(e) => setSheetsUrl(e.target.value)}
          placeholder="https://docs.google.com/spreadsheets/d/.../edit"
        />
      </div>
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
      <div className="mt-auto flex items-center justify-between gap-2">
        <Button type="button" variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button type="button" disabled={!sheetsUrl.trim() || pending} onClick={onSubmit}>
          {pending ? "Fetching…" : "Continue"}
        </Button>
      </div>
    </div>
  );
}

/// Slack source step: the OAuth + sync form, plus a way back to the sources.
export function SlackStep({
  workspaceId,
  onSynced,
  onBack,
}: ComponentProps<typeof SlackImportForm> & { onBack: () => void }) {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <SlackImportForm workspaceId={workspaceId} onSynced={onSynced} />
      <div className="mt-auto">
        <Button type="button" variant="outline" onClick={onBack}>
          Back
        </Button>
      </div>
    </div>
  );
}
